import { AnnouncementDetailPage } from '@/components/announcements/announcement-detail-page'

export function CommitteeAnnouncementDetail() {
  return <AnnouncementDetailPage basePath="/committee/announcements" />
}
